

export const STRIPE_API_KEY = 'pk_test_Panj4OS9NOgd5vB2nrYv70p0'